// import packages
import gql from "graphql-tag"

// export gqls
export const GET_MAINTAIN_SERVICES = gql`
  query maintainServices(
    $take: Int
    $skip: Int
    $input: MaintainServiceFilterInput
  ) {
    maintainServices(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        description
        response
        status
        photoUrls
        assignedTime
        finishTime
        company {
          id
          name
        }
        user {
          id
          name
        }
        engineer {
          id
          name
        }
        companyDevice {
          id
          number
          device {
            id
            name
            number
          }
        }
      }
    }
  }
`

export const SUM_MAINTAIN_SERVICE = gql`
  query MaintainServices($input: MaintainServiceFilterInput) {
    maintainServices(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query MaintainServiceFields {
    maintainServiceFields @client {
      name
      title
      order
      show
    }
  }
`

export const GET_MAINTAIN_SERVICE = gql`
  query MaintainService($id: ID!) {
    maintainService(id: $id) {
      id
      description
      response
      status
      photoUrls
      assignedTime
      finishTime
      company {
        id
        name
      }
      user {
        id
        name
      }
      engineer {
        id
        name
        role
      }
      companyDevice {
        id
        number
        device {
          id
          name
          number
        }
      }
    }
  }
`

export const UPDATE_MAINTAIN_SERVICE = gql`
  mutation UpdateMaintainService(
    $id: ID!
    $input: MaintainServiceUpdateInput!
  ) {
    updateMaintainService(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_MAINTAIN_SERVICE = gql`
  mutation CreateMaintainService($input: MaintainServiceCreateInput!) {
    createMaintainService(input: $input) {
      id
    }
  }
`

export const DELETE_MAINTAIN_SERVICE = gql`
  mutation DeleteMaintainService($id: ID!) {
    deleteMaintainService(id: $id)
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies {
      data {
        id
        name
        area
        users {
          id
          name
          role
        }
        companyDevices {
          id
          number
          device {
            id
            number
            name
          }
        }
      }
    }
  }
`
